module.exports = __webpack_public_path__ + "img/47.1.d35be71a.jpg";